import MapIcon from '../assets/mapview.png';
import PerformanceIcon from '../assets/performanceReporting.png';
import PromotionsIcon from '../assets/promotions.png';
import Magnify from '../assets/magnify.png';

export default {
    MapIcon,
    PerformanceIcon,
    PromotionsIcon,
    Magnify,
}
